<script>
import store from "../../public/store/store";

export default {
    name: "SingleSection",
    props: ['sectionId'],
    data() {
        return {
            items: [],
            loading: true,
            message: 'Загрузка...',
            currentPage: 1,
            paginatedData: null,
        }
    },
    created() {
        this.loading = true;

        this.getItems();
    },
    methods: {
        getItems(page = 1) {
            let data = {
                hash: store.getters.getCurrentHash,
                sectionId: this.sectionId,
            };

            axios.post(`/rest/share/section/items?page=${page}`, data).then((response) => {
                this.items = response.data.items;
                this.paginatedData = response.data.paginatedData;
                this.loading = false;
            }).catch((error) => {
                if (error.response.status === 404) {
                    this.message = 'Раздел не найден.';
                }
            });
        }
    }
}
</script>

<template>
    <div>
        <div v-if="loading === false">
            <template v-if="items.length > 0">
                <div v-for="(item, index) in this.paginatedData.data" :key="index">
                    <v-card class="card">
                        <v-card-title>
                            <router-link :to="`/item/${item.id}`">{{ item.name }}</router-link>
                        </v-card-title>
                        <v-card-text v-html="item.description">
                            {{ item.description }}
                        </v-card-text>
                    </v-card>
                    <div>

                    </div>
                </div>
                <div>
                    <v-pagination
                        v-model="currentPage"
                        :length="paginatedData.last_page"
                        @input="getItems"
                        color="page-active"
                    ></v-pagination>
                </div>
            </template>
            <template v-else>
                <div>
                    <p>Записей не найдено.</p>
                </div>
            </template>
        </div>
        <div v-else style="width: 100%;">
            {{ this.message }}
        </div>
    </div>
</template>

<style scoped>
.card {
    margin-bottom: 30px;
}
</style>
